<template>
<div class="column col full-width">
  <div style="flex:0 0 40px">
    <div class="row" style="padding-bottom: 6px;">
      <div class="row text-h6">
        {{title}}
        <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;" />
      </div>
      <q-space />
      <div class="row text-caption" style="align-items:center">
        <health-check-widget
          ref="health-check"
          :functionCheck="healthCheckFunction"
        />
      </div>
    </div>
  </div>

  <div class="full-width" style="flex:0 0 32px;max-height:32px;">
    <q-btn-group dense spread>
      <q-btn dense rounded :icon="state.mode == 'canvas' ? 'done' : 'none'" label="캔버스 모드" style="color:white;" :style="{ background: selectCanvasBackground }" @click="state.mode='canvas'" />
      <q-separator vertical />
      <q-btn dense rounded :icon="state.mode == 'file' ? 'done' : 'none'" label="파일 모드" style="color:white;" :style="{ background: selectFileBackground }" @click="state.mode='file'" />
    </q-btn-group>
  </div>

  <div style="flex:0 0 15px;" />

  <div class="column col full-width">
    <div v-if="state.mode == 'canvas'" class="column col full-width">
      <div class="column col bg-white shadow-1 full-width">
        <div class="bg-primary" style="padding:10px 20px;">
          <q-btn round color="cyan-5" icon="edit" style="margin-right:7px;" title="펜 모드: 쓰기" @click="state.canvas.mode = 'pen'">
            <q-badge v-if="state.canvas.mode == 'pen'" color="red" floating>✓</q-badge>
          </q-btn>
          <q-btn round color="cyan-5" icon="edit_off" style="margin:0px 7px;" title="펜 모드: 지우개" @click="state.canvas.mode = 'eraser'">
            <q-badge v-if="state.canvas.mode == 'eraser'" color="red" floating>✓</q-badge>
          </q-btn>
          <q-btn round color="cyan-5" icon="border_color" style="margin:0px 7px;" title="획 두께" @click="state.dialogStrokeWidth.show = true">
          </q-btn>
          <q-btn round color="cyan-5" icon="delete" style="margin:0px 7px;" title="캔버스 지우기" @click="$refs['canvas'].clearCanvas()" />
          <q-btn round color="cyan-5" icon="play_arrow" style="margin:0px 7px;" title="인식" @click="listen__recognition__onclick" />
        </div>
        <q-separator />
        <div class="row col full-height full-width">
          <canvas-component
            class="canvas"
            ref="canvas"
            :mode="state.canvas.mode"
            :strokeWidth="state.canvas.strokeWidth"
          />
          <div class="rtab row full-height full-width" :class="{col: state.tab == 'image'}" style="border-left:1px solid rgb(210, 210, 210);overflow:auto;">
            <result :formulas=formulas />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="column col full-width"
      oncontextmenu="return false"
      @dragenter="listen__x__ondragenter"
      @dragleave="listen__x__ondragleave"
      @dragover="listen__x__ondragover"
      @drop="listen__x__ondrop"
      >

      <sample-image-list
        :images="sampleImages"
        :image-width="100"
        @jobstart="showLayer"
        @joberror="(param) => listen__x__onfileerror(param)"
        @jobdone="(file) => preprocessingFile(file)"
      />

      <div style="flex:0 0 15px;" />

      <div class="column col bg-white shadow-1 full-width">
        <div class="bg-primary" style="padding:10px 10px;">
          <q-file dark color="white" ref="file" label="파일 업로드..." v-model="compositionFileData.files" dense accept="image/*" @input="preprocessingFile">
            <template v-slot:prepend>
              <q-icon name="attach_file" />
            </template>
          </q-file>
        </div>
        <q-separator />
        <div class="row col full-height full-width">
          <div class="row col full-height full-width">
            <image-view
              :frame-data="frameData1"
              :pred="pred"
              class="col full-height full-width"
              :passive="false"
              :initial-tool-option="state.currentFrameToolOption"
              :messages-upload="['\'샘플 이미지\'를 선택,', '\'파일 업로드...\'를 클릭,', '또는 이미지를 여기로 \'드래그\' 하여', '인식을 시작합니다.']"
              @onstatechange="listen__image_view__onstatechange" />
          </div>

          <div class="rtab row full-height full-width" :class="{col: state.tab == 'image'}" style="border-left:1px solid rgb(210, 210, 210);overflow:auto;">
            <result :formulas=formulas />
          </div>
        </div>
      </div>
      
      <q-inner-loading :showing="compositionDropData.counterDrag > 0">
        <div class="text-h3">드롭하세요.</div>
      </q-inner-loading>
    </div>
  </div>
  
  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{ state.loadingLayer.message }}
  </q-inner-loading>

  <q-dialog v-model="state.dialogStrokeWidth.show">
    <q-card style="width: 300px" class="q-px-sm q-pb-md">
      <q-card-section>
        <div class="text-h6">획 두께</div>
      </q-card-section>
      <q-item class="row" dense>
        <div class="row" style="align-items:center;flex:0 0 50px;">
          <span>{{ parseInt(state.canvas.strokeWidth) }}</span>
        </div>
        <div class="row col" style="align-items:center;justify-content:flex-end">
          <q-slider color="teal" v-model="state.canvas.strokeWidth" label :min="1" :max="80" :step="1" />
        </div>
      </q-item>
    </q-card>
  </q-dialog>

  <q-dialog v-model="state.dialogHelp">
    <q-card>
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        다음 오픈소스를 참조하여 개발되었다.
        <br />
        <a href="https://github.com/Green-Wood/BTTR">https://github.com/Green-Wood/BTTR</a>
        <br />
        지원 가능한 심볼은 다음과 같다.
        <img src="@/assets/math_symbol.jpg" width="100%" />
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Project Page</div>
        <a href="https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=164761776">https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=164761776</a>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Johan
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
</div>
</template>

<script>
import compositionDrop from '@/composition/drop.js'
import compositionFile from '@/composition/file.js'

import MixinLayer from '@/mixins/layer.js'

import SampleImageList from '@/components/SampleImageList2.vue'
import ImageView from '@/projects/ocr/views/ImageView.vue'
import Result from '@/projects/experimental/components/MathExpressionResult.vue'
import CanvasComponent from '@/projects/experimental/components/Canvas.vue'
import HealthCheckWidget from '@/components/healthCheckWidget.vue'

import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'
import CommExperimental from '@/js/comm_experimental.js'

import {getCurrentInstance} from '@vue/composition-api'

export default {
  setup () {
    const vm = getCurrentInstance()
    if (null == vm ) {
      return {}
    }
    const {compositionFileData, preprocessingImageFile} = compositionFile(vm)
    function preprocessingFile(data) {
      const file = data instanceof File ? data : data.file
      return preprocessingImageFile(file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
    }
    const {compositionDropData, listen__x__ondragenter, listen__x__ondragleave, listen__x__ondragover, listen__x__ondrop} = compositionDrop(preprocessingFile)
    return {
      compositionDropData,
      listen__x__ondragenter,
      listen__x__ondragleave,
      listen__x__ondragover,
      listen__x__ondrop,
      compositionDrop,
      compositionFileData,
      preprocessingFile
    }
  },
  mixins: [MixinLayer],
  data: function () {
    return {
      state: {
        dialogHelp: false,
        dialogStrokeWidth: {
          show: false
        },
        mode: 'canvas',
        canvas: {
          mode: 'pen',
          strokeWidth: 3
        },
        tab: 'text',
        currentFrameState: {
          coord: {
            x: 0,
            y: 0
          },
          zoom: undefined,
          voi: {
            windowCenter: 127,
            windowWidth: 256
          }
        },
        currentFrameToolOption: { mouseButtonMask: 2, lineWidth: 2},
        bboxShow: true
      },
      sampleImages: [
        {
          name: 'UN19_1045_em_646',
          url: 'https://live.staticflickr.com/65535/52196896024_1db26ab7fd_o_d.png'
        },
        {
          name: '003',
          url: 'https://live.staticflickr.com/65535/52196650013_95b7a8bc1c_o_d.png'
        },
        {
          name: '007',
          url: 'https://live.staticflickr.com/65535/52195625352_ca069a3cc7_o_d.png'
        },
        {
          name: 'basic__test_0.xml__111',
          url: 'https://live.staticflickr.com/65535/52196633271_aa17fc5226_o_d.png'
        },
        {
          name: '1000____2',
          url: 'https://live.staticflickr.com/65535/52196633351_8b0125c996_o_d.png'
        },
        {
          name: '10038____3',
          url: 'https://live.staticflickr.com/65535/52196649948_168a7c2fc1_o_d.png'
        }
      ],
      frameData1: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      pred: [],
      formulas: [],
      jsonData: [],
      title: "수식 인식(2022)"
    }
  },
  components: {
    SampleImageList,
    ImageView,
    Result,
    CanvasComponent,
    HealthCheckWidget
  },
  methods: {
    listen__x__onfilechange: function (file) {
      const Vue = this
      
      Vue.clearData()
      Vue.showLayer('이미지를 읽는 중...');
      
      MISC.doubleRaf(async () => {
        let image;
        
        let tokens = file.name.split('.');
        let ext = tokens[tokens.length - 1].toLowerCase();
        try {
          image = await PARSE.parseImage(file, ext);
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
          return
        }
        let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);

        Vue.showLayer('인식 중...');
        let ret = {};
        let formulas = []
        try {
          ret = await CommExperimental.recognizeMathExpression(file, true, false);
          // console.log(ret)
          formulas = Array.from(new Set(ret.data.candidates.map(v => v.join(' '))))
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'red', message: err})
          return
        }
        Vue.frameData1 = {
          id: MISC.getUuid4(),
          name: file.name,
          cornerstoneImage,
          _empty: false
        };
        Vue.formulas = formulas
        Vue.jsonData = ret.data;
        Vue.hidingLayer()
      });
    },
    listen__x__onfileerror: function (param) {
      const Vue = this

      Vue.jsonData = []
      Vue.compositionFileData.files = []
      Vue.clearData()
      Vue.hidingLayer()

      let color = param.color
      if (color == undefined)
        color = 'black'

      Vue.$q.notify({
        message: param.message,
        icon: 'announcement',
        color
      })
    },
    listen__image_view__onstatechange: function (data) {
      if (data.coord != undefined)
        this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
      if (data.zoom != undefined)
        this.state.currentFrameState.zoom = data.zoom
      if (data.voi != undefined)
        this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
      const imageView2 = this.$refs['image-view2']
      if (imageView2 != undefined) {
        imageView2.tostatechange(data)
      }
    },
    listen__btn_bbox__onclick: function () {
      this.state.bboxShow = !this.state.bboxShow;
      
      this.updateTagging()
    },
    listen__recognition__onclick: function () {
      const Vue = this

      this.formulas = []
      Vue.showLayer('이미지를 읽는 중...');
      
      MISC.doubleRaf(async () => {
        const dataUrl = Vue.$refs['canvas'].$refs['canvas-handwriting'].toDataURL()
        Vue.showLayer('인식 중...');
        let ret = {};
        let formulas = []
        try {
          ret = await CommExperimental.recognizeMathExpression(dataUrl, false, true);
          formulas = Array.from(new Set(ret.data.candidates.map(v => v.join(' '))))
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'red', message: err})
          return
        }
        Vue.formulas = formulas
        Vue.jsonData = ret.data;
        Vue.hidingLayer()
      })
    },
    clearData: function () {
      this.frameData1 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      
      this.formulas = []
    },
    healthCheckFunction: CommExperimental.recognizeMathExpression,
    getAddress: function () {
      const Vue = this
      return Vue.$refs['health-check'] == undefined ? '' : Vue.$refs['health-check'].getAddress()
    }
  },
  computed: {
    selectCanvasBackground: function () {
      return this.state.mode == 'canvas' ? 'rgb(2, 123, 227)' : 'rgb(73, 158, 231)';
    },
    selectFileBackground: function () {
      return this.state.mode == 'file' ? 'rgb(2, 123, 227)' : 'rgb(73, 158, 231)';
    }
  },
  watch: {
    'state.mode': function () {
      this.clearData()
      this.formulas = []
      this.state.files = []
    }
  },
  async mounted () {
    const Vue = this
    Vue.$refs['health-check'].listen__healthcheck__onclick()
  }
}
</script>

<style scoped>
.rtab:not(.col) {
  flex: 0 0 400px;
  height: 100%;
}

@media (max-width: 1000px) {
  .image-tool-btn-group {
    display: none !important;
  }
}
</style>